"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AttributionDeleteButton = _interopRequireDefault(require("composer-lib/components/clips/AttributionDeleteButton"));

var _AttributionEditButton = _interopRequireDefault(require("composer-lib/components/clips/AttributionEditButton"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _default = (0, _createReactClass.default)({
  displayName: "Attribution",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    attribution: _propTypes.default.string,
    isCollectBeta: _propTypes.default.bool,
    readOnly: _propTypes.default.bool.isRequired,
    updateAttribution: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      deletePopoverOpen: false,
      editPopoverOpen: false,
      selected: false
    };
  },
  toggleDeletePopover: function toggleDeletePopover() {
    this.setState(function (prevState) {
      return {
        deletePopoverOpen: !prevState.deletePopoverOpen
      };
    });
  },
  toggleEditPopover: function toggleEditPopover() {
    this.setState(function (prevState) {
      return {
        editPopoverOpen: !prevState.editPopoverOpen
      };
    });
  },
  onMouseEnter: function onMouseEnter() {
    this.setState({
      selected: true
    });
  },
  onMouseLeave: function onMouseLeave() {
    this.setState(function (prevState) {
      var deletePopoverOpen = prevState.deletePopoverOpen,
          editPopoverOpen = prevState.editPopoverOpen;

      if (!(deletePopoverOpen || editPopoverOpen)) {
        return {
          selected: false
        };
      }

      return prevState;
    });
  },
  closeDeletePopover: function closeDeletePopover() {
    this.setState({
      deletePopoverOpen: false
    });
  },
  closeEditPopover: function closeEditPopover() {
    this.setState({
      editPopoverOpen: false
    });
  },
  renderDeleteButton: function renderDeleteButton() {
    var _this$props = this.props,
        isCollectBeta = _this$props.isCollectBeta,
        readOnly = _this$props.readOnly,
        updateAttribution = _this$props.updateAttribution;
    var _this$state = this.state,
        deletePopoverOpen = _this$state.deletePopoverOpen,
        selected = _this$state.selected;

    if (readOnly || !selected) {
      return null;
    }

    return _react.default.createElement(_AttributionDeleteButton.default, {
      closePopover: this.closeDeletePopover,
      openPopover: deletePopoverOpen,
      isCollectBeta: isCollectBeta,
      togglePopover: this.toggleDeletePopover,
      updateAttribution: updateAttribution
    });
  },
  renderEditButton: function renderEditButton() {
    var _this$props2 = this.props,
        attribution = _this$props2.attribution,
        isCollectBeta = _this$props2.isCollectBeta,
        readOnly = _this$props2.readOnly,
        updateAttribution = _this$props2.updateAttribution;
    var _this$state2 = this.state,
        editPopoverOpen = _this$state2.editPopoverOpen,
        selected = _this$state2.selected;

    if (readOnly || !selected) {
      return null;
    }

    return _react.default.createElement(_AttributionEditButton.default, {
      attribution: attribution,
      closePopover: this.closeEditPopover,
      openPopover: editPopoverOpen,
      isCollectBeta: isCollectBeta,
      togglePopover: this.toggleEditPopover,
      updateAttribution: updateAttribution
    });
  },
  renderControls: function renderControls() {
    return _react.default.createElement("span", null, this.renderEditButton(), this.renderDeleteButton());
  },
  render: function render() {
    var attribution = this.props.attribution;
    var selected = this.state.selected;

    if (!attribution) {
      return null;
    }

    var className = (0, _classnames.default)('attribution', {
      selected: selected
    });
    return _react.default.createElement("div", {
      className: className,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave
    }, _react.default.createElement("span", null, attribution, this.renderControls()));
  }
});

exports.default = _default;
module.exports = exports.default;